import { DatabaseUtilityService } from '../../../services/databaseUtility.service'
import { NowIndexDbService } from '../../../services/nowIndexDb.service'
import { IPcrBackupMetadata } from '../store/pcrBackup.types'
import Logger from '../../../services/logger.service'

export class PcrBackupMetadataService {
  private db: NowIndexDbService

  constructor(database: string) {
    this.db = DatabaseUtilityService.getIndexDbServiceInstance(database)
  }

  private get tableName(): string {
    return this.db.pcrBackupMetadata.name
  }

  async getMetadata(pcrId: string): Promise<IPcrBackupMetadata | null> {
    try {
      const result = await this.db.get<IPcrBackupMetadata>(pcrId, this.tableName)
      return result ?? null
    } catch (error) {
      Logger.errorObj(`PcrBackupMetadataService: Error getting metadata for pcrId ${pcrId}`, error)
      return null
    }
  }

  async getOverdueBackupPcrs(intervalMs: number): Promise<IPcrBackupMetadata[]> {
    try {
      const cutoff = Date.now() - intervalMs
      return await this.db.pcrBackupMetadata
        .filter((m) => !m.lastSuccessfulBackupTime || m.lastSuccessfulBackupTime <= cutoff)
        .toArray()
    } catch (error) {
      Logger.errorObj('PcrBackupMetadataService: Error getting overdue metadata', error)
      return []
    }
  }

  async upsertMetadata(metadata: IPcrBackupMetadata): Promise<void> {
    try {
      await this.db.save(metadata, this.tableName)
    } catch (error) {
      Logger.errorObj(`PcrBackupMetadataService: Error upserting metadata for pcrId ${metadata.pcrId}`, error)
    }
  }

  async deleteMetadata(pcrId: string): Promise<void> {
    try {
      await this.db.remove(pcrId, this.tableName)
    } catch (error) {
      Logger.errorObj(`PcrBackupMetadataService: Error deleting metadata for pcrId ${pcrId}`, error)
    }
  }
}
